import React, { useEffect, useContext } from "react";
import { Input, Row, Col, Container, CustomInput } from "reactstrap";
import { onChangeHeader, onChange } from "../../IO";
import Files from "../../Fields/Files/Files";
import { LocalINTL, SimpleSuggest } from "../../Fields";
import { CurrencyAsset, IOTransferType } from "../../../../IO/types";
import { Combobox, Numeric, Field } from "../../../Order/Field/Field";
import { Dispatch } from "../../store/store";
import Account from "../../Fields/Account";
import { commissionSuffix } from "../../../Order/Form/commons";
import Bulk from "../Bulk/Bulk";
import { updateAccountBanks, isEmpty } from "../Default";

const DepositBulk = ({opsViewAccountName}) => {
  const { dispatch, services, state } = useContext(Dispatch);
  const { ui, io, fields, entities, permissions } = state;
  const { errors, readonly, hiddens } = fields;
  const { allowValues, allowCash } = permissions;
  const header = io.itemsHeader;

  useEffect(() => {
    //console.log(io);
    if (header.IsCurrency && !header.BankAccountIsThirdParty) {
      if (!isEmpty(header.AccountId) ) {
        if (state.io.Status === "Filled"){
          dispatch({
            type: "UPDATE_ACCOUNT_BANKS",
            accountBanks: [{
              BankAccountHolders: header.BankAccountHolders,
              BankAccountId: header.BankAccountId,
              BankAccountItemId: header.BankAccountItemId,
              BankAccountName: header.BankAccountName,
              BankAccountNumber: header.BankAccountNumber,
            }],
          });
        }else{
        services
          .fetchGetAccountBanks({
            accountId: header.AccountId,
            currencyId: 0,
          })
          .then((r) => r.response)
          .then((r) => {
            dispatch({
              type: "UPDATE_ACCOUNT_BANKS",
              accountBanks: r.accountBanks,
            });
            if (header.BankAccountItemId === null && r.accountBanks) {
              const item = r.accountBanks[0];
              onChangeHeader(dispatch, {
                ...item,
              });
            } else {
              const item = r.accountBanks.find(
                (a) => a.BankAccountItemId === header.BankAccountItemId,
              );
              onChangeHeader(dispatch, {
                ...item,
              });
            }
          });
        }
      } else {
        dispatch({ type: "UPDATE_ACCOUNT_BANKS", accountBanks: [] });
        onChangeHeader(dispatch, {
          BankAccountItemId: null,
          BankAccountName: null,
        });
      }
    }
  }, [header.AccountId]);

  // XOR operator
  const readOnlyTypeSelector = allowValues ? !allowCash : allowCash;
  const accountEmpty = header.AccountId == null || header.AccountId == 0;
  const currencyEmpty = header.CurrencyId == null || header.CurrencyId == 0;

  return (
    <Container>
      <Row>
        {/* Left */}
        <Col xs={6} lg={6}>
          <Row className="mb-2" style={{ marginTop: "15px" }}>
            <Col lg={6} xs={6}>
              <LocalINTL
                isLocal={io.Local}
                readonly={readonly.Local}
                onChange={(v) => onChange(dispatch, v)}
              />
            </Col>
            <Col lg={6} xs={6}>
              <Combobox
                darken
                disabled={readonly.header_IsCurrency || readOnlyTypeSelector}
                onChange={(v) =>
                  onChangeHeader(dispatch, {
                    IsCurrency: v == CurrencyAsset.Cash,
                  })
                }
                value={
                  header.IsCurrency ? CurrencyAsset.Cash : CurrencyAsset.Asset
                }
                items={Object.values(CurrencyAsset).map((key, index) => ({
                  id: key,
                  description: key,
                }))}
              />
            </Col>
          </Row>
        </Col>
      </Row>

      <Row>
        <Col lg={6} xs={12}>
          {/* Date */}
          <Field label={"Date"} error={errors.Date}>
            <Input
              tabIndex="3"
              type="date"
              placeholder={"Date"}
              disabled={readonly.Date}
              value={io.Date}
              invalid={!!errors.Date}
              onChange={(e) => onChange(dispatch, { Date: e.target.value })}
            />
          </Field>

          {/* Settlement Date */}
          <Field label={"Settlement Date"} error={errors.SettlementDate}>
            <Input
              tabIndex="3"
              type="date"
              placeholder={"Settlement Date"}
              disabled={readonly.SettlementDate}
              value={io.SettlementDate}
              invalid={!!errors.SettlementDate}
              onChange={(e) =>
                onChange(dispatch, { SettlementDate: e.target.value })
              }
            />
          </Field>
        </Col>

        {/* Right */}
        <Col xs={12} lg={6}>
          {/* ##### Account ###### */}
          <Account
            AccountId={header.AccountId}
            AccountName={header.AccountName}
            AccountNumber={header.AccountNumber}
            HolderId={header.HolderId}
            HolderName={header.HolderName}
            onChange={(values) => onChangeHeader(dispatch, values)}
            readonly={{
              AccountNumber:readonly.header_AccountNumber,
              AccountName: readonly.header_AccountName,
              HolderName: readonly.header_HolderName,
            }}
            errors={{
              AccountNumber: errors.header_AccountNumber,
              AccountName: errors.header_AccountName,
              HolderName: errors.header_HolderName,
            }}
            services={{
              fetchAccountHolders: services.fetchAccountHolders,
              fetchSearchAccount: services.fetchSearchAccount,
            }}
            opsViewAccountName={opsViewAccountName}
          />
        </Col>
      </Row>

      <Row>
        <Col lg={12}>
          <Bulk />
        </Col>
      </Row>

      <Row>
        <Col xs={12} lg={6}>
          {header.IsCurrency && io.Local && (
            <React.Fragment>
              <Field label={"Type"} error={errors.header_TransferType}>
                <Combobox
                  value={header.TransferType}
                  items={[
                    { id: "Transfer", description: "Transfer" },
                    { id: "Cash", description: "Cash" },
                    { id: "Cheque", description: "Cheque" },
                  ]}
                  disabled={readonly.header_Quantity}
                  invalid={!!errors.header_TransferType}
                  onChange={(v) =>
                    onChangeHeader(dispatch, { TransferType: v })
                  }
                  emptyLabel={"Type"}
                />
              </Field>

              {/* ##### Bank Account ##### */}
              {header.TransferType === IOTransferType.Transfer && (
                <React.Fragment>
                  <div className="mt-2 mb-2">
                    <CustomInput
                      label="Third party bank account"
                      type="checkbox"
                      id={`cbox-thirdParty`}
                      checked={header.BankAccountIsThirdParty || false}
                      disabled={readonly.header_BankAccountIsThirdParty}
                      onChange={(v) =>
                        onChangeHeader(dispatch, {
                          BankAccountIsThirdParty: !header.BankAccountIsThirdParty,
                        })
                      }
                    />
                  </div>
                  {header.BankAccountIsThirdParty ? (
                    <React.Fragment>
                      <SimpleSuggest
                        label={"Third party bank"}
                        service={services.fetchSearchCustodianEntity}
                        error={errors.header_BankAccountName}
                        disabled={readonly.simple_Quantity}
                        value={header.BankAccountName || ""}
                        onChange={({ id, name }) =>
                          onChangeHeader(dispatch, {
                            BankAccountId: id,
                            BankAccountName: name,
                          })
                        }
                      />

                      <Field
                        label={"Third party bank account"}
                        error={errors.header_BankAccountNumber}
                      >
                        <Input
                          type={"text"}
                          placeholder={"Account"}
                          value={header.BankAccountNumber || ""}
                          invalid={errors.header_BankAccountNumber}
                          onChange={(e) =>
                            onChangeHeader(dispatch, {
                              BankAccountNumber: e.target.value,
                            })
                          }
                          disabled={readonly.header_Quantity}
                        />
                      </Field>
                    </React.Fragment>
                  ) : (
                    <Field
                      label={"Bank Account"}
                      error={errors.header_BankAccountName}
                      description={
                        accountEmpty || currencyEmpty
                          ? "First select an account and currency"
                          : null
                      }
                    >
                      <Combobox
                        value={header.BankAccountItemId}
                        items={entities.accountBanks.map((a) => ({
                          id: a.BankAccountItemId,
                          description: `${a.BankAccountName} - ${a.BankAccountNumber}`,
                        }))}
                        disabled={
                          accountEmpty ||
                          currencyEmpty ||
                          readonly.header_Quantity
                        }
                        invalid={!!errors.header_BankAccountName}
                        onChange={(id) =>
                          onChangeHeader(
                            dispatch,
                            entities.accountBanks.find(
                              (a) => a.BankAccountItemId == id
                            )
                          )
                        }
                        emptyLabel={"Bank Account"}
                      />
                    </Field>
                  )}
                </React.Fragment>
              )}

              {/* ##### Cheque ##### */}
              {header.TransferType === IOTransferType.Cheque && (
                <React.Fragment>
                  {/* ##### Third party bank ###### */}
                  <SimpleSuggest
                    label={"Bank"}
                    service={services.fetchSearchCustodianEntity}
                    error={errors.header_BankAccountName}
                    disabled={readonly.simple_Quantity}
                    value={header.BankAccountName || ""}
                    onChange={({ id, name }) =>
                      onChangeHeader(dispatch, {
                        BankAccountId: id,
                        BankAccountName: name,
                      })
                    }
                  />

                  <Field label={"#Cheque"} error={errors.header_ChequeNumber}>
                    <Input
                      type={"text"}
                      placeholder={"Number"}
                      value={header.ChequeNumber || ""}
                      invalid={errors.header_ChequeNumber}
                      onChange={(e) =>
                        onChangeHeader(dispatch, {
                          ChequeNumber: e.target.value,
                        })
                      }
                      disabled={readonly.header_Quantity}
                    />
                  </Field>
                </React.Fragment>
              )}
            </React.Fragment>
          )}

          <Row>
            {/* ##### Commission ###### */}
            <Col lg={6}>
              <Field label={"Commission"} error={errors.header_Commission}>
                <Numeric
                  value={header.Commission}
                  placeholder={`Commission`}
                  disabled={readonly.header_Commission}
                  onChange={(v) => onChangeHeader(dispatch, { Commission: v })}
                  invalid={!!errors.header_Commission}
                  {...commissionSuffix(null)}
                  dataTypeDecimalName="currency"
                />
              </Field>
            </Col>

            {/* ##### CommissionType ###### */}
            <Col lg={6}>
              <Field label={"Type"} error={errors.header_CommissionType}>
                <Combobox
                  value={header.CommissionType}
                  items={[
                    { id: "FaceValueCash", description: "$ Cash" },
                    { id: "PrincipalPercentage", description: "% Principal" },
                  ]}
                  disabled={readonly.header_CommissionType}
                  invalid={!!errors.header_CommissionType}
                  onChange={(v) =>
                    onChangeHeader(dispatch, { CommissionType: v })
                  }
                  emptyLabel={"Type"}
                  style={{ background: "#edf9ff", fontWeight: 500 }}
                />
              </Field>
            </Col>
          </Row>
        </Col>
        <Col xs={12} lg={6}>
          <Files
            id={io.Id}
            ioType={io.IOType}
            readonly={readonly.Quantity}
            dispatch={dispatch}
            files={io.files}
            downloadFile={services.fetchDownloadIOFile}
          />

          {/* ##### Custodian ###### */}
          <SimpleSuggest
            label={"Received in"}
            service={services.fetchSearchCustodian}
            error={errors.CustodianName}
            disabled={readonly.CustodianName}
            value={io.CustodianName}
            onChange={({ id, name }) => {
              onChange(dispatch, { CustodianId: id, CustodianName: name });
            }}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default DepositBulk;
